/* eslint-disable */
import { MutationTree } from 'vuex';

import { Travel, Result, Generics } from '@/core/types';

import { State } from './state';
import { PersonalMutationTypes } from '@/core/enum/Personals/Mutations';

export type Mutations<S = State> = {
  [PersonalMutationTypes.SET_CUSTOMER](state: S, payload: Travel): void;
  [PersonalMutationTypes.SET_CUSTOMER_MEMBERS](state: S, payload: Array<Generics>): void;
  [PersonalMutationTypes.SET_CUSTOMER_RESULT](state: S, payload: Result): void;
  [PersonalMutationTypes.SET_CUSTOMER_LOADING](state: S, payload: boolean): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [PersonalMutationTypes.SET_CUSTOMER](state: State, customer: any) {
    state.customer = customer;
  },
  [PersonalMutationTypes.SET_CUSTOMER_MEMBERS](state: State, members: Array<Generics>) {
    state.travellers_info = members;
  },
  [PersonalMutationTypes.SET_CUSTOMER_RESULT](state: State, result: Result) {
    state.result = result;
  },
  [PersonalMutationTypes.SET_CUSTOMER_LOADING](state: State, loading: boolean) {
    state.loading = loading;
  },
  [PersonalMutationTypes.SET_CUSTOMER_EXISTING_LEADS](state: State, existingLeads: any) {
    state.existingLeads = existingLeads;
  },
  [PersonalMutationTypes.SET_CUSTOMER_RECENT_LEADS](state: State, recent_searches: any) {
    state.recent_searches = recent_searches;
  },
  [PersonalMutationTypes.SET_CUSTOMER_EXISTING_SELECTED_LEADS](state: State, selectedLeads: any) {
    state.selectedLeads = selectedLeads;
  },
  [PersonalMutationTypes.SET_EXIST_CLICK](state: State, exist_click: boolean) {
    state.exist_click = exist_click;
  },
};
